export enum AvailableColumns {
    NsContactName = 'nsContactName',
    Deal = 'deal',
    FirstName = 'firstName',
    MiddleName = 'middleName',
    LastName = 'lastName',
    Permission = 'permission',
    Shareholder = 'shareholder',
    EmailStatus = 'emailStatus',
    Actions = 'actions',
}
